import api from '../axios-instance';

import type { ComboSummary } from '../types/ComboSummary';
import type { ApiResponse, ErrorResponse } from './api.types';
import type { ComboCoverageViewModel } from '../types/ComboCoverageViewModel';

export const comboService = {
  getCombos: async (): Promise<ApiResponse<ComboSummary[]>> => {
    try {
      const response = await api.get('/combos');
      return { data: response.data, status: response.status };
    } catch (error) {
      throw error as ErrorResponse;
    }
  },

  getCombosById: async (id: number): Promise<ApiResponse<ComboCoverageViewModel>> => {
    try {
      const response = await api.get(`/combocoverages/${id}`);

      return { data: response.data, status: response.status };
    } catch (error) {
      throw error as ErrorResponse;
    }
  },
};
